import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { FeatureAnnouncementKey } from "../../../constants/featureAnnouncements";

export interface FeatureAnnouncementSummary {
  featureKey: FeatureAnnouncementKey;
  version: string;
  title: string;
  publishedAt: string;
  seen: boolean;
}

export interface FeatureAnnouncementsState {
  announcements: FeatureAnnouncementSummary[];
  reopenRequestId: number;
  requestedAnnouncement: {
    featureKey: FeatureAnnouncementKey;
    version: string;
  } | null;
}

const initialState: FeatureAnnouncementsState = {
  announcements: [],
  reopenRequestId: 0,
  requestedAnnouncement: null,
};

const slice = createSlice({
  name: "featureAnnouncements",
  initialState,
  reducers: {
    setAnnouncements(state, action: PayloadAction<FeatureAnnouncementSummary[]>) {
      state.announcements = action.payload;
    },
    markAnnouncementSeen(state, action: PayloadAction<Pick<FeatureAnnouncementSummary, "featureKey" | "version">>) {
      const announcement = state.announcements.find(
        ({ featureKey, version }) => featureKey === action.payload.featureKey && version === action.payload.version
      );
      if (announcement) announcement.seen = true;
    },
    requestAnnouncementOpen(state, action: PayloadAction<Pick<FeatureAnnouncementSummary, "featureKey" | "version">>) {
      // A counter lets repeated clicks create a new event; a boolean would remain true after the first click.
      state.reopenRequestId += 1;
      state.requestedAnnouncement = action.payload;
    },
  },
});

export const { setAnnouncements, markAnnouncementSeen, requestAnnouncementOpen } = slice.actions;
export default slice.reducer;
